import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getDetailsFromSearchParams } from '../utils/getDetailsFromSearchParams';

export function useGetPageCacheKey(pageType: string, pageId: string | null) {
  const [urlSearchParams] = useSearchParams();

  const cacheKey = useMemo(() => {
    if (pageType === 'detailPage') {
      const { detailsDiscriminator, detailsValue } =
        getDetailsFromSearchParams(urlSearchParams);
      if (detailsDiscriminator == null || detailsValue == null) {
        const message =
          detailsDiscriminator == null
            ? 'A detail page was opened without specifying proper details parameters: Details discriminator is missing.'
            : `A detail page was opened without specifying proper details parameters: Value for details discriminator "${detailsDiscriminator}" is missing.`;

        throw new Error(message);
      }
      return `${pageId}/${detailsDiscriminator}/${detailsValue}`;
    }
    return pageId;
  }, [pageType, pageId, urlSearchParams]);

  return cacheKey;
}
